<ion-header class="ion-no-border">
  <ion-toolbar color="light">
    <ion-buttons slot="end">
      <ion-button size="small" color="primary" role="link" (click)="skip()">
        {{ 'onboarding.step.skip' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="app__content onboarding">
    <div class="onboarding__content">
      <img
        alt="{{ 'Logo ' + appName }}"
        class="logo"
        *ngIf="appIcon"
        [src]="appIcon"
      />
      <h1>{{ 'onboarding.welcome.title' | translate:{appName: appName} }}</h1>
      <p>{{ 'onboarding.welcome.desc' | translate:{appName: appName} }}</p>
      <h2>{{ 'onboarding.preference.title' | translate }}</h2>
      <div
        class="preference ion-activatable"
        role="button"
        (click)="chooseArea()"
      >
        <img src="/assets/images/area.png" />
        <div class="preference__content">
          <h3>{{ 'onboarding.preference.area' | translate }}</h3>
          <p>{{ 'onboarding.preference.area.desc' | translate }}</p>
        </div>
        <span inlineSVG="/assets/icons/arrow-right.svg"></span>
        <ion-ripple-effect></ion-ripple-effect>
      </div>
      <div
        class="preference ion-activatable"
        role="button"
        (click)="chooseProjects()"
      >
        <img class="contain" src="/assets/images/projects.png" />
        <div class="preference__content">
          <h3>{{ 'onboarding.preference.projects' | translate }}</h3>
          <p>{{ 'onboarding.preference.projects.desc' | translate }}</p>
        </div>
        <span inlineSVG="/assets/icons/arrow-right.svg"></span>
        <ion-ripple-effect></ion-ripple-effect>
      </div>
    </div>
    <div
      tabindex="0"
      role="link"
      class="onboarding__terms"
      (click)="openPrivacyStatement()"
    >
      {{ "page.settings.privacy.desc" | translate }}
    </div>
  </div>
</ion-content>
